export default {
  id: "abcAnalysisValue",
  name: "",
  description: "",
  report: {
    name: "Total value by price",
    chartType: "",
    template: "abc-analysis-value",
    config: {
      dataType: "single",
      dataSet: "ABCInventoryAnalysis",
      dimensions: ["ABCInventoryAnalysis.grade_string_revenue"],
      measures: [
        "ABCInventoryAnalysis.total_revenue",
        "InventoryItem.qty_on_hand_retail_amount",
      ],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "3",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
      applyDateRangeFilter: false,
      filterDateRange: false,
    },
  },
};
